export const FOLLOWER_UPSET_SUCCESS = "FOLLOWER_UPSET_SUCCESS";
export const FOLLOWER_UPSET_FAILED = "FOLLOWER_UPSET_FAILED";

export const PROFILE_ITEM_ATTEMPT = "PROFILE_ITEM_ATTEMPT";
export const PROFILE_ITEM_SUCCESS = "PROFILE_ITEM_SUCCESS";
export const PROFILE_ITEM_FAILED = "PROFILE_ITEM_FAILED";


